<h2 mat-dialog-title>
  <mat-icon> bookmark </mat-icon>
  {{ 'Cambio de estado de equipo' }}
</h2>
<mat-dialog-content class="mat-typography">

  <form [formGroup]="formGroup">
    <mat-form-field class="input-width-50" appearance="outline">
      <mat-label>Estado de equipo</mat-label>
      <mat-select formControlName="status">
        @for (item of statusList; track item) {
          <mat-option
            [matTooltip]="item"
            matTooltipPosition="left"
            [value]="item">
            {{ item }}
          </mat-option>
        }
      </mat-select>
      <mat-error> Especialidad es <strong>requerido</strong> </mat-error>
    </mat-form-field>
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="update()">Guardar</button>
</mat-dialog-actions>
